import React from 'react';
import { Link } from 'react-router-dom';
import flamingo  from '../assets/pngegg_white.png'


function Header() {
  return (
    <header className="custom-header-color py-3">
      <nav className="container d-flex justify-content-between align-items-center">
        <Link to="/" className="text-white text-decoration-none">
					<img src={flamingo} alt="" width="30" height="30" />
        </Link>
        {/* Wrap the navigation items in a div with flex */}
        <div className="d-flex">
          <ul className="list-unstyled mb-0 d-flex">
            <li className="nav-item">
              <Link to="/projects" className="text-white text-decoration-none mx-3">
                Projects
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/blog" className="text-white text-decoration-none mx-3">
                Blog
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
}

export default Header;
